import { BaseApi } from "../BaseApi";
import { InterceptToken } from "../../interceptors/TokenInterceptor";

const validarProcedimientoUrl =
  "api/v1/websalud/primeraars/procedimientos/validacion";
const insertarProcedimientoUrl = "api/v1/websalud/primeraars/procedimientos";

const eliminarProcedimientoUrl = (request) =>
  `api/v1/websalud/primeraars/procedimientos/${request.codigoProcedimiento}`;

const validarProcedimiento = (request) =>
  InterceptToken(
    BaseApi.post,
    validarProcedimientoUrl,
    request.requestData,
    request.requestHeaders
  ).then((response) => response.data);

const insertarProcedimiento = (request) =>
  InterceptToken(
    BaseApi.post,
    insertarProcedimientoUrl,
    request.requestData,
    request.requestHeaders
  ).then((response) => response.data);

const eliminarProcedimiento = (request) =>
  InterceptToken(
    BaseApi.delete,
    eliminarProcedimientoUrl(request.requestData),
    null,
    request.requestHeaders
  ).then((response) => response.data);

const exportedObject = {
  validarProcedimiento,
  insertarProcedimiento,
  eliminarProcedimiento,
};

export default exportedObject;